export class RangeDeleteData {
  sourceId: string;
  idsToDelete: string[];

  constructor(sourceId: string, idsToDelete: string[]) {
    this.sourceId = sourceId;
    this.idsToDelete = idsToDelete;
  }
}
